/* ============================================================
   LEARN — the article's reading line.
   A hairline of indigo along the top of the window that fills as
   you read: scroll progress through the article body maps straight
   onto its width. Scroll-coupled geometry, not animation, so it is
   honest under reduced motion; rAF-throttled like the house engine.
   ============================================================ */

const line = document.querySelector('[data-read-line]');
const bodyEl = document.querySelector('[data-article-body]');

if (line && bodyEl) {
  const absTop = el => { let y = 0; for (let n = el; n; n = n.offsetParent) y += n.offsetTop; return y; };
  let start = 0, end = 1, frame = 0;
  const measure = () => {
    start = absTop(bodyEl) - 120;
    end = Math.max(start + 1, absTop(bodyEl) + bodyEl.offsetHeight - innerHeight + 120);
  };
  const draw = () => {
    frame = 0;
    const p = Math.min(1, Math.max(0, (scrollY - start) / (end - start)));
    line.style.transform = `scaleX(${p.toFixed(4)})`;
  };
  addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(draw); }, { passive: true });
  addEventListener('resize', () => { if (!frame) frame = requestAnimationFrame(() => { measure(); draw(); }); }, { passive: true });
  addEventListener('load', () => { measure(); draw(); }, { once: true });
  measure();
  draw();
}
